
import { Inject, Injectable } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import { BehaviorSubject, Observable } from "rxjs";
import { map } from "rxjs/operators";
import { AppSettings } from "./AppSettings";
import { GigsumoConstants } from "./GigsumoConstants";
import { ApiService } from "./api.service";
import { widgetData } from "./job.service";
import { UserModel, WorkExperience } from "./userModel";
import { UtilService } from "./util.service";
import { GigsumoService } from "./gigsumoService";

export type responseObject<Tdata =  any> = {
  status?: string;
  searchText?: string;
  userId?: string;
  userType ?: string;
  limit?: number;
  interactionType : "CANDIDATE_INVITED" |  "JOB_APPLIED" | "RESUME_REQUESTED" | "RESUME_DOWNLOADED";
  searchAfterKey?: Array<any>;
  pageNumber?: number;
  createdBy?: string;
  content ?: string ,
  data : Tdata ,
};

type PROFILE_DETAIL_PAYLOAD = Pick<responseObject , "userId" | "userType">;
export type PROFILE_LISTENER = Pick<responseObject<WorkExperience> , "content" |  "data">
export type USER_TYPE = 'RECRUITER' | 'BENCH_RECRUITER' | 'FREELANCE_RECRUITER' | 'MANAGEMENT_TALENT_ACQUISITION' | 'JOB_SEEKER';
interface UserData {
  userType: USER_TYPE,
  userId: string,
  notificationCount?: number
}


@Injectable({
  providedIn : "root"
})
export class userPlanProvider {

  private usertPlanDetails : any = {};

  setPlanDetails(v:any){
    this.usertPlanDetails = v;
  }

  updatePlan(planName : string){
    this.usertPlanDetails.membershipType = planName;
  }

  get userPlan() {
    if(this.userPlanDetails){
      return this.userPlanDetails.membershipType;
    }
  }

  get userPlanDetails() {
    return this.usertPlanDetails;
  }

}





@Injectable({
  providedIn: "root",
})
export class UserService {
  private userDataSubject: BehaviorSubject<UserData> = new BehaviorSubject<UserData>(null);
  userData$: Observable<UserData> = this.userDataSubject.asObservable();
  lablechangeclienttype:any;

  private timeZoneSubject: BehaviorSubject<string | undefined> =
  new BehaviorSubject<string | undefined>(localStorage.getItem('timezonedate') ?? undefined);
  timeZone$: Observable<string | undefined> = this.timeZoneSubject.asObservable();

  constructor(private API: ApiService,private util:UtilService, private userPLanProvider : userPlanProvider,
    private gigsumoService: GigsumoService
  ) {

  }



  setUserData(userData: UserData):void {
    localStorage.setItem('userType', userData.userType);
    this.userDataSubject.next(userData);
  }

  userConnection(data): Observable<any> {
    return this.API.create("user/connect", data);
  }


  async userProfileDetails(data: {} | any) {
    const profileResponse = await this.API.create('user/profileDetails', data).toPromise();    
    
    if(!profileResponse){
      console.log("profile response :: ",profileResponse);
      this.gigsumoService.buttonClicked = true;
    }
    if (profileResponse.code != GigsumoConstants.SUCESSCODE) {
      throw new Error("Server Exception");
    }
    localStorage.setItem("timezonedate", profileResponse.data.userData.timeZone);
    this.timeZoneSubject.next(profileResponse.data.userData.timeZone);
    return profileResponse.data;
  }


  getDisableValues(form: UntypedFormGroup, key: string): any {
    let formValue = form.getRawValue();
    return formValue[key];
  }
  userConnectionList( data: widgetData
  ): Observable<any> {

    return this.API.create("user/activeContatcts", data).pipe(
      map((connectionList) => {
        this.util.stopLoader();
        if(connectionList.code != "00000"){
          throw new Error("There is some issue with Server");
        }
        connectionList.data.activeContatcts.forEach(user => {
          user.page = "connectionList";
      });
        return connectionList.data;
      })
    );
  }


  updatePlan(planName : string){
    if(planName){
      this.userPLanProvider.updatePlan(planName);
    }
    else{
      throw new Error("planName cannot be empty");
    }
  }


  updateUserPlanDetails(v : any){
    this.userPLanProvider.setPlanDetails(v);
  }


  async intializeUserPlanDetails(){
    let planbenefits: any = await this.API.lamdaFunctionsget('findUserPlanBenefits/' + localStorage.getItem('userId'));
    this.userPLanProvider.setPlanDetails(planbenefits.data.userPlanAndBenefits);
  }


  async checkIfUserHasCurrentOrganization(value : PROFILE_DETAIL_PAYLOAD) : Promise<boolean>{
    // this.util.startLoader();
    let hasCurrentOrganization : boolean = false;
    const profileData = await this.userProfileDetails(value);
    const { exeperienceList } =  profileData;
    // this.util.stopLoader();
    if(Array.isArray(exeperienceList) && exeperienceList.length > 0){
        exeperienceList.forEach((element : WorkExperience)=>{
          if(element.currentOrganization){
            hasCurrentOrganization = true;
          }
        });
    }
    else  hasCurrentOrganization = false;

    return hasCurrentOrganization;
  }

  // querying the userComplete status functionality here
  userProfileComplete(userId : string) : Observable<UserModel> {
   return this.API.query("user/profile/complete/" + userId).pipe(
    map( userData=>{
      if (userData && userData.photo !== undefined) {
        if (userData.photo === null || userData.photo === undefined || userData.photo === "") {
          userData.photo = null;
        } else if (!userData.photo.startsWith('http://') && !userData.photo.startsWith('https://')) {
          // Only prepend base URL if photo doesn't already have a full URL
          userData.photo = AppSettings.photoUrl + userData.photo;
        }
        this.defaultLocalData(userData);
      }
       return userData;
    })
   );

  }
  getuservalues(callback: (lablechangeclienttype: string) => void) {

    const userId = localStorage.getItem('userId');
    this.API.query('user/' + userId).subscribe(
      (res) => {

        callback(res.clientType);
      },
      (err) => {

      }
    );
  }

  // setting the userDetails in localStorage
  defaultLocalData(userData : UserModel){
    localStorage.setItem('currentOrganization', userData.organisation);
  }


  async sentOtpToMail(data : unknown) : Promise<any>{
    return await this.API.create("user/sendOtpToMailId", data).toPromise();
  }

  async verifyOtp(data : unknown) : Promise<any>{
    return await this.API.create("user/verifyOTP", data).toPromise();
  }





  onlineAPI(status:string){
    let url = 'user/onlineoroffline';
      let user = {
        userId: localStorage.getItem('userId'),
        online: status.toUpperCase()
      };
      this.util.startLoader()
      this.API.create(url, user).subscribe(res => {
        this.util.stopLoader()
      }, err => {
        this.util.stopLoader();

      });
  }

}
